import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { jsx } from '@emotion/react/jsx-runtime';

function TrackingLastUpdateLabel(props) {
  const {
    t
  } = useTranslation();
  return jsx(Typography, {
    variant: "small",
    component: "div",
    ...props,
    children: t('tracking-details.checkpoints.last-update')
  });
}

export { TrackingLastUpdateLabel };
//# sourceMappingURL=TrackingLastUpdateLabel.js.map
